import React from "react"
import { Spinner } from "../ui/spinner"

type LoadingScreenProps = {}

export const LoadingScreen: React.FC<LoadingScreenProps> = (props) => {
	return (
		<div className="h-screen w-screen flex items-center justify-center">
			<Spinner />
		</div>
	)
}
